// src/pages/nbaRoute.ts
import {
  renderNBAPlayerCard,
  initNBAPlayerCardEvents,
} from "../components/nba/NBAPlayerCard";
import type { NBAPlayer } from "../components/nba/NBAPlayerCard";

export function renderNBARoute(player: NBAPlayer) {
  const app = document.getElementById("app");
  if (!app) return;

  app.innerHTML = `
    <div class="nba-route-wrapper">
      ${renderNBAPlayerCard(player, true)}
    </div>
  `;

  initNBAPlayerCardEvents(app);
}
